var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconeEnvelopeAbertoBranco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 22.8,
    viewBox: "0 0 24 22.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillRule: "evenodd",
    d: "M23.9880371 8.40002441c.00585938-.83032226-.42169189-1.60351562-1.12799071-2.04003906L12 0 1.14001465 6.35998535C.4307251 6.79510498-.00115967 7.5678711 0 8.40002441v12c.00396729 1.3237915 1.07617188 2.3959961 2.40002441 2.39996338h19.20001221C22.92388916 22.79602051 23.99609375 21.72381592 24 20.40002441l-.0119629-12zm-2.4000244 0v.0119629L12 14.4000244l-9.59997559-6L12 2.78399658l9.5880127 5.61602783zM2.4000244 11.20800781v9.1920166h19.20001221l-.01202392-9.15600586L12 17.23199463 2.40002441 11.2080078z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeEnvelopeAbertoBranco);
export default __webpack_public_path__ + "static/media/icone-envelope-aberto-branco.be167ecd0c71ece10d6cd675c5b014e7.svg";
export { ForwardRef as ReactComponent };